/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/credit_limit_adjustment';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "AcknowledgeCreditLimitAdjustmentViewedRequest": {
                "fields": {
                  "creditLimitAdjustmentIdentifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AcknowledgeCreditLimitAdjustmentViewedResponse": {
                "fields": {
                  "creditLimitAdjustment": {
                    "type": ".squareup.corporate_card.resources.CreditLimitAdjustment",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AcknowledgeCreditLimitAdjustmentViewedRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AcknowledgeCreditLimitAdjustmentViewedResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AcknowledgeCreditLimitAdjustmentViewedRequest @ squareup/corporate_card/service/acknowledge_credit_limit_adjustment_viewed.proto at 9:1
 */
export const AcknowledgeCreditLimitAdjustmentViewedRequest = $root.lookupType('squareup.corporate_card.service.AcknowledgeCreditLimitAdjustmentViewedRequest');
fixType(AcknowledgeCreditLimitAdjustmentViewedRequest, {
  creditLimitAdjustmentIdentifier: {
    required: true
  }
});
Builder.createAndAttachToType(AcknowledgeCreditLimitAdjustmentViewedRequest);
/**
 * SOURCE AcknowledgeCreditLimitAdjustmentViewedResponse @ squareup/corporate_card/service/acknowledge_credit_limit_adjustment_viewed.proto at 13:1
 */
export const AcknowledgeCreditLimitAdjustmentViewedResponse = $root.lookupType('squareup.corporate_card.service.AcknowledgeCreditLimitAdjustmentViewedResponse');
fixType(AcknowledgeCreditLimitAdjustmentViewedResponse, {
  creditLimitAdjustment: {
    required: true
  }
});
Builder.createAndAttachToType(AcknowledgeCreditLimitAdjustmentViewedResponse);